import { iframeResizerContentWindow } from 'iframe-resizer'; // eslint-disable-line no-unused-vars
import React, { PropTypes } from 'react';
import DocumentHeadContainer from '../../../containers/DocumentHeadContainer';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default class WidgetLayout extends BcReactComponent {
  getChildContext() {
    return { isWidget: true };
  }

  componentDidMount() {
    if ('parentIFrame' in window && this._root) {
      // The setTimeout fixes race condition with iframe height calculation by removing it from the event loop
      setTimeout(() => {
        window.parentIFrame.autoResize(false);
        window.parentIFrame.size(this._root.clientHeight);
        window.parentIFrame.autoResize(true);
      }, 0);
    }
  }

  render() {
    return (
      <div className="cp-widget-layout" ref={(el) => { this._root = el; }}>
        <DocumentHeadContainer />
        {this.props.children}
      </div>
    );
  }
}

WidgetLayout.propTypes = propTypes;
WidgetLayout.childContextTypes = {
  isWidget: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/layouts/WidgetLayout/WidgetLayout.jsx